import React from "react";
import Box from "@mui/material/Box";
import Item from "../../Template/Item";
import Stack from "@mui/material/Stack";

interface IMonthlyWeekHeadProps {
  weekDays: string[];
}

export default function MonthlyWeekHead(props: IMonthlyWeekHeadProps) {
  const { weekDays } = props;
  function renderWeekHeads() {
    return weekDays.map((weekDay, index) => {
      return (
        <Stack key={index} spacing={2} sx={{ width: "14.28%" }}>
          <Item
            sx={{
              whiteSpace: "nowrap",
              textAlign: "center",
              overflow: "hidden",
            }}
          >
            {weekDay}
          </Item>
        </Stack>
      );
    });
  }
  return <Box display={"flex"}>{renderWeekHeads()}</Box>;
}
